import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'ProductFamilies',
  //   description: 'description of ProductFamilies',
  //   url: '/product-families',
  // },
];

export default help;
